import { save, load } from "redux-localstorage-simple";
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux'
import ReduxThunk     from 'redux-thunk';
import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';

import reducers from './reducers';
export const browserHistory = createHistory();
const routingMiddleware = routerMiddleware(browserHistory);

const storageConf = {
  states:['user']
}
const enhancer = compose(
  applyMiddleware(
    routingMiddleware,
    ReduxThunk,
    save(storageConf)
  ),
  window.devToolsExtension ? window.devToolsExtension() : f => f,
);

export const store = createStore(reducers, load(storageConf), enhancer);



// WEBPACK FOOTER //
// ./src/redux/config.js